/**
 * ChartLegend component export
 */

export { default } from "./ChartLegendContainer";
